import { PDFDocument, StandardFonts } from "pdf-lib";
import JcrSign from "./JcrSign.png"

const editPdf = async (type, pdf, clientTime, formInputData, cipVersion = "Quantitative Data Collection") => {

  const clientName = formInputData.companyName
  const clientAddress = formInputData.companyAddress
  const financePersonName = formInputData.financePersonName
  const financePersonDesignation= formInputData.financePersonDesignation  
  const url = pdf;
  const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const timesRomanBold = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);
  const TimesRoman = await pdfDoc.embedFont(StandardFonts.TimesRoman)
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const lastPage = pages[pages.length - 1]
  const { width, height } = firstPage.getSize();
  let clientImage = null
  let clientSignDims = null
  const jcrSignatureImageBytes = await fetch(JcrSign).then(res => res.arrayBuffer())
  const jcrSignatureImage = await pdfDoc.embedPng(jcrSignatureImageBytes)
  const jcrSignDims = jcrSignatureImage.scale(0.08)






  function ndaHeadingPosition() {
    if ((clientName.length * 3) < 123) {
      return -92
    }
    else {

      const offset = clientName.length * 3 - 123
      return -152 + offset
    }
  }
  function slaHeadingPosition() {

    if ((clientName?.length * 3) < 235) {
      return -45
    }
    else {

      const offset = clientName?.length * 3 - 123
      return -45 - offset
    }


  }

  switch (type) {
    case 'nda':
      firstPage.drawText(clientTime, {
        x: width / 2 + 30,
        y: height / 2 + 195.5,
        size: 10,
        font: timesRomanBold,
      });
      firstPage.drawText(clientName, {
        x: width / 2 + ndaHeadingPosition(),
        y: height / 2 + 181.5,
        size: 10,
        font: timesRomanBold,
      });
      firstPage.drawText(clientName, {
        x: width / 2 - 84.5,
        y: height / 2 + 122,
        size: 10,
        font: timesRomanBold,
      });
      firstPage.drawText(clientName, {
        x: width / 2 - 64.5,
        y: height / 2 + 39,
        size: 10,
        font: timesRomanBold,


      });
      firstPage.drawText(clientName, {
        x: width / 2 - 85,
        y: height / 2 - 6,
        size: 10,
        font: timesRomanBold,


      });
      firstPage.drawText(clientName, {
        x: width / 2 + 39,
        y: height / 2 + 73,
        size: 10,
        font: timesRomanBold,


      });


      firstPage.drawText(clientAddress, {
        x: width / 2 + ndaHeadingPosition() + 5,
        y: height / 2 + 170,
        size: 10,
        font: timesRomanBold,
      });
      lastPage.drawText(clientName, {
        x: width / 2 - 230,
        y: height / 2 - 285,
        size: 10,
        font: timesRomanBold,
      });

      lastPage.drawText(financePersonName, {
        x: width / 2 - 210,
        y: height / 4 - 115,
        size: 10,
        font: timesRomanBold,
      });

      lastPage.drawText(financePersonDesignation, {
        x: width / 2 - 210,
        y: height / 4 - 125,
        size: 10,
        font: timesRomanBold,
      });

    
      lastPage.drawImage(jcrSignatureImage, {
        x: width / 2 + 65,
        y: height / 4 - 135,
        width: jcrSignDims.width + 100,
        height: jcrSignDims.height + 40
      })

      break;
    case 'sla_msa':
      switch (cipVersion) {
        case "Quantitative Data Collection":
          firstPage.drawText(clientTime, {
            x: width / 2 + 100,
            y: height / 2 + 295,
            size: 10,
            font: timesRomanBold,
          });
          firstPage.drawText(clientName, {
            x: width / 2 + slaHeadingPosition() - 35,
            y: height / 2 + 282,
            size: 10,
            font: timesRomanBold,
          });
          firstPage.drawText(clientAddress, {
            x: width / 2 + slaHeadingPosition() - 15,
            y: height / 2 + 270,
            size: 10,
            font: timesRomanBold,
          });
          lastPage.drawText(clientName, {
            x: width / 2 - 220,
            y: height / 4 + 115,
            size: 10,
            font: timesRomanBold,


          });
          

          lastPage.drawText(clientTime, {
            x: width / 2 - 190,
            y: height / 4 + 40,
            size: 10,
            font: timesRomanBold,
          });

          lastPage.drawImage(jcrSignatureImage, {
            x: width / 2 + 75,
            y: height / 4 + 90,
            width: jcrSignDims.width + 120,
            height: jcrSignDims.height + 50
          })
          lastPage.drawText(financePersonName, {
            x: width / 2 - 190,
            y: height / 4 + 98,
            size: 10,
            font: timesRomanBold,
          });

          lastPage.drawText(financePersonDesignation, {
            x: width / 2 - 190,
            y: height / 4 + 70,
            size: 10,
            font: timesRomanBold,
          });
          break;
        case "Quantitative + Qualitative + Desk Research":
          firstPage.drawText(clientTime, {
            x: width / 2 + slaHeadingPosition() - 132,
            y: height / 2 + 278,
            size: 10,
            font: timesRomanBold,
          });
          firstPage.drawText(clientName, {
            x: width / 2 + slaHeadingPosition() - 42,
            y: height / 2 + 292,
            size: 10,
            font: timesRomanBold,
          });
          // firstPage.drawText("clientAddress", {
          //   x: width / 2 + slaHeadingPosition() - 15,
          //   y: height / 2 + 270,
          //   size: 50,
          //   font: timesRomanBold,
          // });
          lastPage.drawText(clientName, {
            x: width / 2 - 255,
            y: height / 4 + 340,
            size: 10,
            font: timesRomanBold,


          });
        

          lastPage.drawText(clientTime, {
            x: width / 2 - 220,
            y: height / 4 + 270,
            size: 10,
            font: timesRomanBold,
          });

          lastPage.drawImage(jcrSignatureImage, {
            x: width / 2 + 75,
            y: height / 4 + 300,
            width: jcrSignDims.width + 120,
            height: jcrSignDims.height + 50
          })
          lastPage.drawText(financePersonName, {
            x: width / 2 - 220,
            y: height / 4 + 325,
            size: 10,
            font: timesRomanBold,
          });

          lastPage.drawText(financePersonDesignation, {
            x: width / 2 - 220,
            y: height / 4 + 300,
            size: 10,
            font: timesRomanBold,
          });
          break;

        default:
          break;
      }

    default:
      break;
  }
  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
};



export default editPdf;